import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import AnimateHeight from 'react-animate-height'
import get from 'lodash.get'

import { CustomLink } from '../../utils/linkResolver'
import widont from '../../utils/widont'

import theme from '../../styles/theme'
import { Button } from '../../styles/Buttons'
import { Heading2, Heading4, Paragraph } from '../../styles/Text'

const items = [
  {
    heading: 'Realtime charts and graphs',
    description:
      'Update dashboards in realtime, whatever the metric: stock tickers, cryptocurrency prices, application metrics, and more.',
    link: '',
    link_text: 'Find out more',
    icon: {
      url: '/images/live-chat.svg',
    },
    icon_hover: {
      url: '/images/live-chat-hover.svg',
    },
  },
  {
    heading: 'Presence indicators',
    description: 'Show who is online right now in a document, game, chat, or any other collaborative app.',
    link: '',
    link_text: 'Find out more',
    icon: {
      url: '/images/live-chat.svg',
    },
    icon_hover: {
      url: '/images/live-chat-hover.svg',
    },
  },
  {
    heading: 'Realtime location',
    description:
      'Display the realtime location of a food delivery, share a dynamic location with friends, or even create a geofence to trigger location-based alerts.',
    link: '',
    link_text: 'Find out more',
    icon: {
      url: '/images/live-chat.svg',
    },
    icon_hover: {
      url: '/images/live-chat-hover.svg',
    },
  },
  {
    heading: 'Gaming',
    description: 'Synchronize game state between players, and add multi-user interactions to your games and apps.',
    link: '',
    link_text: 'Find out more',
    icon: {
      url: '/images/live-chat.svg',
    },
    icon_hover: {
      url: '/images/live-chat-hover.svg',
    },
  },
  {
    heading: 'Collaboration and activity feeds',
    description:
      'Update a live list of events to display the latest activity and comments in any social or professional network.',
    link: '',
    link_text: 'Find out more',
    icon: {
      url: '/images/live-chat.svg',
    },
    icon_hover: {
      url: '/images/live-chat-hover.svg',
    },
  },
  {
    heading: 'Chat',
    description: 'Drive engagement and upgrade customer satisfaction with feature rich in-app chat functionality.',
    link: '',
    link_text: 'Find out more',
    icon: {
      url: '/images/live-chat.svg',
    },
    icon_hover: {
      url: '/images/live-chat-hover.svg',
    },
  },
  {
    heading: 'Realtime results',
    description:
      'Display the status of anything in realtime, including match scores, odds updates, live election results or polls.',
    link: '',
    link_text: 'Find out more',
    icon: {
      url: '/images/live-chat.svg',
    },
    icon_hover: {
      url: '/images/live-chat-hover.svg',
    },
  },
]

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Accordion = () => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  return (
    <>
      <Heading>Accordion</Heading>
      {items?.map((item, index) => {
        return (
          <Dropdown
            item={item}
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
            itemNr={index}
            key={index}
          />
        )
      })}
    </>
  )
}

export default Accordion

const DropdownWrapper = styled.div`
  position: relative;
  transition: ease-in-out 0.2s;
  border-radius: 4px;
  :not(:last-child) {
    margin-bottom: 8px;
  }
  svg,
  path {
    transition: ease-in-out 0.2s;
  }
  a {
    display: flex;
  }
  :hover {
    background-color: #7d6cad;
    color: white;
    path {
      stroke: white;
    }
    img:nth-child(2) {
      opacity: 1;
    }
  }
  ${(p) =>
    p.isSelected &&
    css`
      background-color: ${(p) => p.theme.textColor};
      :hover {
        background-color: ${(p) => p.theme.textColor};
      }
      color: white;
      path {
        stroke: white;
      }
      svg {
        transform: rotate(180deg);
      }
    `}
`

const TopWrapper = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px 16px;
`

const Icon = styled.div`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  margin-right: 16px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-height: 100%;
  }
  img:nth-child(2) {
    transition: ease-in-out 0.2s;
    opacity: 0;
    position: absolute;
    top: 0px;
    left: 0px;
    ${(p) => p.active && 'opacity: 1;'}
  }
`

const CustomHeading = styled(Heading4)`
  flex-grow: 1;
  text-align: left;
`

const Caret = styled.div`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`

const BottomWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 56px;
  a {
    margin-right: 32px;
    margin-bottom: 16px;
    @media (min-width: ${(p) => p.theme.breakpointMd}) {
      margin-right: auto;
    }
  }
`

const DropdownDescription = styled(Paragraph)`
  margin-top: 8px;
  margin-bottom: 16px;
  padding: 0px 32px 0px 0px;
`

const CTAButton = styled(Button)`
  line-height: 22px;
  min-height: 44px;
  width: 100%;
  @media (min-width: ${(p) => p.theme.breakpointMd}) {
    width: initial;
    max-width: 172px;
  }
  @media (min-width: ${(p) => p.theme.breakpointLg}) {
    max-width: initial;
  }
`

const Dropdown = ({ item, selectedIndex, setSelectedIndex, itemNr }) => {
  const heading = get(item, 'heading')
  const description = get(item, 'description')
  const link = get(item, 'link')
  const linkText = get(item, 'link_text')
  const iconUrl = get(item, 'icon.url')
  const iconHoverUrl = get(item, 'icon_hover.url')

  const height = itemNr === selectedIndex ? 'auto' : 0

  return (
    <DropdownWrapper isSelected={height === 'auto'}>
      <TopWrapper onClick={() => setSelectedIndex(itemNr)}>
        {iconUrl && (
          <Icon active={height === 'auto'}>
            <img src={iconUrl} alt="" />
            <img src={iconHoverUrl} alt="" />
          </Icon>
        )}
        {heading && <CustomHeading>{heading}</CustomHeading>}
        <Caret isSelected={height === 'auto'}>
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.51465 8.92123L11.9999 17.4065"
              stroke="#300D4F"
              strokeWidth="3"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20.4854 8.92126L12.0001 17.4065"
              stroke="#300D4F"
              strokeWidth="3"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Caret>
      </TopWrapper>
      <AnimateHeight duration={500} height={height}>
        <BottomWrapper>
          {description && <DropdownDescription>{widont(description)}</DropdownDescription>}
          {linkText && (
            <CustomLink link={link}>
              <CTAButton reversedWhite textColor={theme.textColor} fullWidthOnSmall>
                {linkText}
              </CTAButton>
            </CustomLink>
          )}
        </BottomWrapper>
      </AnimateHeight>
    </DropdownWrapper>
  )
}
